import { render, staticRenderFns } from "./RegulationsApproval.vue?vue&type=template&id=ced92092"
import script from "./RegulationsApproval.vue?vue&type=script&lang=js"
export * from "./RegulationsApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports